import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "my-section" }
const _hoisted_3 = {
  key: 0,
  class: "container my-8 px-10"
}
const _hoisted_4 = {
  key: 1,
  class: "container my-8 px-10"
}
const _hoisted_5 = { class: "my-title" }
const _hoisted_6 = { class: "flex flex-col align-items-center justify-content-center flex-column space-y-5 my-subtitle py-8" }
const _hoisted_7 = { class: "px-5 font-medium" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Ultimo Login: ")
const _hoisted_9 = { class: "font-light" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_11 = {
  key: 2,
  class: "flex flex-col md:flex-row-reverse justify-center items-center"
}
const _hoisted_12 = { class: "flex-grow-0 w-full lg:w-6/12" }
const _hoisted_13 = { class: "my-form border-double border-2 rounded-lg" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "my-subtitle py-8" }, "RICARICHE (admin)", -1)
const _hoisted_15 = { class: "my-form--field" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, "ORE DI RICARICA", -1)
const _hoisted_17 = { class: "my-form--field--label" }
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<option value=\"5\">5</option><option value=\"10\">10</option><option value=\"15\">15</option><option value=\"20\">20</option><option value=\"25\">25</option><option value=\"30\">30</option><option value=\"35\">35</option><option value=\"40\">40</option><option value=\"45\">45</option><option value=\"50\">50</option><option value=\"55\">55</option><option value=\"60\">60</option><option value=\"65\">65</option><option value=\"70\">70</option><option value=\"75\">75</option><option value=\"80\">80</option><option value=\"85\">85</option><option value=\"90\">90</option><option value=\"95\">95</option><option value=\"100\">100</option>", 20)
const _hoisted_38 = [
  _hoisted_18
]
const _hoisted_39 = { class: "my-form--field" }
const _hoisted_40 = { class: "my-form--field--field" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" RICARICA ")
const _hoisted_42 = {
  key: 4,
  class: "flex flex-col md:flex-row-reverse justify-center items-center mt-6"
}
const _hoisted_43 = { class: "flex-grow-0 w-full lg:w-10/12" }
const _hoisted_44 = { class: "my-form border-double border-2 rounded-lg" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "my-subtitle py-8" }, [
  /*#__PURE__*/_createTextVNode(" CONTROL PANEL (ADMIN !!!) "),
  /*#__PURE__*/_createElementVNode("h3", null, " In questa sezione possiamo mandare il json imp_macchina, selezionando i valori desiderati "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("h4", null, [
    /*#__PURE__*/_createTextVNode(" Se stiamo inizializzando la macchina, mandare tutto a zero, e \"is_full\" a 1 se la macchina non è a ricarica "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Altrimenti mettere a 1 il valore desiderato e premere Invia ")
  ])
], -1)
const _hoisted_46 = { class: "my-form--field flex-column flex-sm-row justify-center items-center" }
const _hoisted_47 = { class: "my-form--field mx-2" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label font-bold" }, "IS_FULL", -1)
const _hoisted_49 = { class: "my-form--field--label" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "0", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "1", -1)
const _hoisted_52 = [
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = { class: "my-form--field mx-2" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label font-bold" }, "BLOCCO", -1)
const _hoisted_55 = { class: "my-form--field--label" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "0", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "1", -1)
const _hoisted_58 = [
  _hoisted_56,
  _hoisted_57
]
const _hoisted_59 = { class: "my-form--field mx-2" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label font-bold" }, " CANCELLA ORE ", -1)
const _hoisted_61 = { class: "my-form--field--label" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "0", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "1", -1)
const _hoisted_64 = [
  _hoisted_62,
  _hoisted_63
]
const _hoisted_65 = { class: "my-form--field mx-2" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label font-bold" }, " AGG SOFTWARE ", -1)
const _hoisted_67 = { class: "my-form--field--label" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "0", -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "1", -1)
const _hoisted_70 = [
  _hoisted_68,
  _hoisted_69
]
const _hoisted_71 = { class: "my-form--field" }
const _hoisted_72 = { class: "my-form--field--field flex-col lg:flex-row" }
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" INVIA ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TagWidget = _resolveComponent("TagWidget")!
  const _component_TableGeneralInfo = _resolveComponent("TableGeneralInfo")!
  const _component_TableManipoli = _resolveComponent("TableManipoli")!
  const _component_TableTemperatures = _resolveComponent("TableTemperatures")!
  const _component_TableErrori = _resolveComponent("TableErrori")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TableRicaricheEffettuate = _resolveComponent("TableRicaricheEffettuate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.loadingFinished)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Caricamento in corso... "))
        : _createCommentVNode("", true),
      (_ctx.loadingFinished)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_TagWidget, {
                config: _ctx.tipoTagConfig,
                dbData: _ctx.dbData
              }, null, 8, ["config", "dbData"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.dbData?.description), 1),
              _createElementVNode("a", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.dbData?.lastLogin), 1)
              ])
            ]),
            _hoisted_10,
            _createVNode(_component_TableGeneralInfo, { machineData: _ctx.dbData }, null, 8, ["machineData"]),
            (_ctx.tipoMacchina !== 'XP')
              ? (_openBlock(), _createBlock(_component_TableManipoli, {
                  key: 0,
                  machineData: _ctx.dbData,
                  tipoMacchina: _ctx.tipoMacchina
                }, null, 8, ["machineData", "tipoMacchina"]))
              : _createCommentVNode("", true),
            (_ctx.tipoMacchina !== 'XP')
              ? (_openBlock(), _createBlock(_component_TableTemperatures, {
                  key: 1,
                  machineData: _ctx.dbData,
                  tipoMacchina: _ctx.tipoMacchina
                }, null, 8, ["machineData", "tipoMacchina"]))
              : _createCommentVNode("", true),
            _createVNode(_component_TableErrori, {
              machineData: _ctx.dbData,
              tipoMacchina: _ctx.tipoMacchina
            }, null, 8, ["machineData", "tipoMacchina"]),
            (_ctx.isAdmin && _ctx.dbData?.heartbeat?.is_full == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("div", _hoisted_17, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ricarica.ore_ricarica) = $event)),
                            class: "my-input",
                            style: {"margin-bottom":"50px"}
                          }, _hoisted_38, 512), [
                            [_vModelSelect, _ctx.ricarica.ore_ricarica]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createVNode(_component_Button, {
                            class: "is-secondary",
                            icon: "fas fa-upload",
                            onClick: _ctx.salvaRicarica
                          }, {
                            default: _withCtx(() => [
                              _hoisted_41
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isAdmin && _ctx.listaRicaricheEffettuate.length > 0)
              ? (_openBlock(), _createBlock(_component_TableRicaricheEffettuate, {
                  key: 3,
                  listaRicaricheEffettuate: _ctx.listaRicaricheEffettuate
                }, null, 8, ["listaRicaricheEffettuate"]))
              : _createCommentVNode("", true),
            (_ctx.isAdmin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _hoisted_48,
                          _createElementVNode("div", _hoisted_49, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.impMacchina.is_full) = $event)),
                              class: "my-input",
                              style: {"margin-bottom":"50px"},
                              required: ""
                            }, _hoisted_52, 512), [
                              [_vModelSelect, _ctx.impMacchina.is_full]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _hoisted_54,
                          _createElementVNode("div", _hoisted_55, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.impMacchina.blocco) = $event)),
                              class: "my-input",
                              style: {"margin-bottom":"50px"},
                              required: ""
                            }, _hoisted_58, 512), [
                              [_vModelSelect, _ctx.impMacchina.blocco]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _hoisted_60,
                          _createElementVNode("div", _hoisted_61, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.impMacchina.cancella_ore) = $event)),
                              class: "my-input",
                              style: {"margin-bottom":"50px"},
                              required: ""
                            }, _hoisted_64, 512), [
                              [_vModelSelect, _ctx.impMacchina.cancella_ore]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          _hoisted_66,
                          _createElementVNode("div", _hoisted_67, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.impMacchina.agg_software) = $event)),
                              class: "my-input",
                              style: {"margin-bottom":"50px"},
                              required: ""
                            }, _hoisted_70, 512), [
                              [_vModelSelect, _ctx.impMacchina.agg_software]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("div", _hoisted_72, [
                          _createVNode(_component_Button, {
                            class: "is-secondary mx-2 mb-2",
                            icon: "fas fa-upload",
                            onClick: _ctx.inizializzaMacchina
                          }, {
                            default: _withCtx(() => [
                              _hoisted_73
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}